import {
  instagramConnectionResponseSchema,
  type InstagramConnectionResponse,
} from "@multi-chat/shared";
import { apiDelete, apiGet } from "./client.js";

function orgBase(organizationId: number): string {
  return `/organizations/${organizationId}/instagram`;
}

export function instagramConnectStartUrl(organizationId: number): string {
  return `${orgBase(organizationId)}/connect/start`;
}

export async function getInstagramConnection(
  organizationId: number,
  signal?: AbortSignal,
): Promise<InstagramConnectionResponse> {
  return instagramConnectionResponseSchema.parse(
    await apiGet(orgBase(organizationId), signal),
  );
}

export async function disconnectInstagram(
  organizationId: number,
  signal?: AbortSignal,
): Promise<InstagramConnectionResponse> {
  return instagramConnectionResponseSchema.parse(
    await apiDelete(orgBase(organizationId), signal),
  );
}
